import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useStreamNotifications = (userId?: string) => {
  useEffect(() => {
    if (!userId) return;

    // Subscribe to streams going live from followed creators
    const channel = supabase
      .channel('stream-notifications')
      .on('postgres_changes', {
        event: 'UPDATE',
        schema: 'public',
        table: 'streams',
        filter: `status=eq.live`
      }, async (payload) => {
        // Check if user follows this creator
        const { data: followData } = await supabase
          .from('follows')
          .select('*')
          .eq('follower_id', userId)
          .eq('following_id', payload.new.creator_id)
          .single();

        if (followData) {
          // Get creator info
          const { data: profileData } = await supabase
            .from('profiles')
            .select('display_name')
            .eq('id', payload.new.creator_id)
            .single();

          toast.success(`🎬 ${profileData?.display_name} is now live!`, {
            description: payload.new.title,
            duration: 10000,
            action: {
              label: 'Watch Now',
              onClick: () => window.location.href = `/stream/${payload.new.id}`
            }
          });
        }
      })
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId]);
};
